export enum BetSlipBetType {
    OneClickBet = 'one-click',
    Normal = 'normal'
};